/**
 * This entrypoint sets the webpack public path based on the `ASSETS_URL` in app-configs.
 */
import appConfig from '@nerdwallet/app-config'; // trailing slash is require for public paths
// eslint-disable-next-line

__webpack_public_path__ = "".concat(appConfig.ASSETS_URL, "/build/");